export function CeleroApiKeyCtrl ($uibModalInstance, $scope, messages, Celero) {
  $scope.celero = new Celero();
  $scope.key    = '';

  $scope.save = function (form) {
    $scope.celero.saveApiKey($scope.key)
    .then(() => {
      $uibModalInstance.close();
    })
    .catch(error => {
      messages.error(error);
    });
  };
}
